import { Component, EventEmitter, OnInit, Output, Input, OnChanges, ViewChild, HostListener } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CfetBaseComponent, CfetService, CfetRegExContant, PasswordMatchValidator, CfetPageNamesConstant } from '../../../cfet-core';
import { PasswordValidationTooltipComponent } from './../../../cfet-shared';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-complete-profile-form',
    templateUrl: './complete-profile-form.component.html',
    styleUrls: ['./complete-profile-form.component.scss'],
    standalone: false
})

export class CompleteProfileFormComponent extends CfetBaseComponent implements OnInit, OnChanges {
  getPersonalInfo: any;
  isFocus = false;
  timeZoneValue: any = { value: '', text: 'Select' };
  SecurityQuestionvalue: any = { value: '', text: 'Select' };
  termsConditionChecked = false;
  totalHeight: number;
  questionExpanded = '';
  timezoneExpanded = '';
  checkPasswordMatch = false;
  isPasswordValid = false;
  showLoading = false;
  openCancelModal = '';
  showCancelModal = false;
  getData: any;
  showInactivityModal = true;
  countDown: any;
  openInactivityModal = '';
  securityQuestions: Array<any> = [];
  timeZoneData: Array<any> = [];
  isChecked = false;
  public securityQuestionsList: any[] = [];
  timeZoneList = [];
  completeProfileFormGroup: UntypedFormGroup;
  emailAddress: UntypedFormControl;
  newPassword: UntypedFormControl;
  confirmPassword: UntypedFormControl;
  securityQuestion: UntypedFormControl;
  securityAnswer: UntypedFormControl;
  timeZone: UntypedFormControl;
  termsChecked: UntypedFormControl;
  isInvalidPassword = false;
  isWeakPassword = false;
  showPassword: boolean;
  errorFlagPArray: any = [];
  @ViewChild('userActivationQTooltip') private UserActivationQTooltip;
  @Output() showCodeSection: any = new EventEmitter<any>();
  @Output() openTermsPage: any = new EventEmitter<any>();
  @ViewChild(PasswordValidationTooltipComponent) PasswordValidationTooltipComponent;
  @Input() showWeekPassword: boolean;
  @Input() isFocusOn: boolean;



  constructor(public cfetService: CfetService) { super(); }

  ngOnChanges() {
    if (this.showWeekPassword) {
      this.cfetService.pwdObj.currentPassword[0] = '';
      this.newPassword.setValue('');
      this.confirmPassword.setValue('');
      this.showPassword = false;
      this.isWeakPassword = true;
      this.errorFlagPArray[0] = true;
      this.cfetService.clearPasswordErrors();
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.emailAddress = new UntypedFormControl('', [Validators.required]);
    const passwordRegEx = new RegExp(CfetRegExContant.pd_format);
    this.confirmPassword = new UntypedFormControl('', {
      validators:
        Validators.compose([Validators.required,
        Validators.minLength(8),
        Validators.maxLength(24),
        Validators.pattern(passwordRegEx)])
    });
    this.newPassword = new UntypedFormControl('', {
      validators:
        Validators.compose([Validators.required,
        Validators.minLength(8),
        Validators.maxLength(24),
        Validators.pattern(passwordRegEx)]),
      updateOn: 'blur'
    });
    this.securityQuestion = new UntypedFormControl('', [Validators.required]);
    this.securityAnswer = new UntypedFormControl('',
      { validators: [Validators.required, Validators.minLength(3)], updateOn: 'blur' });
    this.timeZone = new UntypedFormControl('', [Validators.required]);
    this.termsChecked = new UntypedFormControl('', [Validators.required]);
    this.completeProfileFormGroup = new UntypedFormGroup({
      emailAddress: this.emailAddress,
      confirmPassword: this.confirmPassword,
      newPassword: this.newPassword,
      securityQuestion: this.securityQuestion,
      timeZone: this.timeZone,
      securityAnswer: this.securityAnswer,
      termsChecked: this.termsChecked
    });
    this.completeProfileFormGroup.setValidators(PasswordMatchValidator());

    this.completeProfileFormGroup.valueChanges.subscribe(() => {
      if (this.completeProfileFormGroup.errors || this.completeProfileFormGroup.valid || this.completeProfileFormGroup.invalid) {
        this.isInvalidPassword = (this.newPassword.value.length > 0 && this.confirmPassword.value.length > 0 &&
          this.newPassword.value !== this.confirmPassword.value) ? true : false;
      }
    });

    const commonListValues = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.timeZoneData = commonListValues['validTimeZones'];

    this.getSessionData();
    if (environment.enableSessionTimeout) {
      this.checkInactivity();
    }
    this.loadSecurityQuestions();
  }

  getSessionData() {
    if (this.timeZoneData && this.timeZoneData.length > 0) {
      this.timeZoneList = this.timeZoneData.map(t => {
        return { value: t, text: t };
      });
    }

    if (sessionStorage.getItem('ngStorage-savedData') && Object.keys(sessionStorage.getItem('ngStorage-savedData')).length !== 0) {
      this.getPersonalInfo = JSON.parse(sessionStorage.getItem('ngStorage-savedData'));
      if (this.getPersonalInfo && this.getPersonalInfo.emailaddress) {
        this.emailAddress.setValue(this.getPersonalInfo.emailaddress);
        this.emailAddress.disable();
      }
    }
    if (sessionStorage.getItem('profileInformation') && Object.keys(sessionStorage.getItem('profileInformation')).length !== 0) {
      sessionStorage.removeItem('profileInformation');
    }
    this.getData = sessionStorage.getItem('fromOtpPage') ? JSON.parse(sessionStorage.getItem('fromOtpPage')) : {};
    if (this.getData && this.getData.action && this.getData.action === 'fromOtpPage') {
      this.securityQuestion.setValue(this.getData.securityQuestion);
      this.SecurityQuestionvalue = { value: this.getData.securityQuestion, text: this.getData.securityQuestion };
      this.securityAnswer.setValue(this.getData.securityAnswer);
      this.timeZone.setValue(this.getData.timeZone);
      this.timeZoneValue = { value: this.getData.timeZone, text: this.getData.timeZone };
      this.termsConditionChecked = true;
      this.termsChecked.setValue(true);
    }
  }

  emitedPasswordMethodReset(event) {
    if (event) {
      if (event.pwd) {
        this.cfetService.pwdObj.isErrorCodeArray[event.index] = '';
      }
      this.completeProfileFormGroup.get('newPassword').setValue(event.pwd);
      let errorListFlag;
      errorListFlag = Object.values(event).includes(false);
      this.confirmingPassword(event);
      if (errorListFlag) {
        this.completeProfileFormGroup.get('newPassword').setErrors({
          'pattern': errorListFlag
        });
        this.errorFlagPArray[event.index] = (event.eFlag && event.eFlag[event.index]) ?
          event.eFlag[event.index] : false;
      }
      this.isPasswordValid = (event.capitalLetterRule && event.lengthRule && event.numRule &&
        event.smallLetterRule && event.specialCharsRule && event.length24 &&
        event.repeating3 && event.sequence3) ? true : false;
      if (!this.completeProfileFormGroup.get('newPassword').value && !this.errorFlagPArray[event.index]) {
        this.completeProfileFormGroup.get('newPassword').setErrors(null);
      }
    }
  }

  //LoadingtheSecurityQuestions
  loadSecurityQuestions() {
    const profile = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.securityQuestions = profile['securityQuestions'];
    if (this.securityQuestions.length > 0 && this.securityQuestions) {
      this.securityQuestionsList = this.securityQuestions.map(
        question => {
          return { value: question, text: question };
        }
      );
    }
  }

  confirmingPassword(event) {
    if (this.confirmPassword && (event.pwd === this.confirmPassword.value)) {
      this.completeProfileFormGroup.get('confirmPassword').setErrors(null);
    } else {
      this.isWeakPassword = false;
      this.completeProfileFormGroup.get('confirmPassword').setErrors({ misMatch: true });
    }
  }

  selectQuestions(event): void {
    if (event.key === 'Enter' || event.type === 'click') {
      this.questionExpanded = '';
      this.completeProfileFormGroup.patchValue({
        securityQuestion: event.value
      });
    }
  }

  onClickSecurityQuestion(event) {
    if (event.target.ariaExpanded === 'true') {
      this.questionExpanded = 'dropdown-opened';
    } else {
      this.questionExpanded = '';
    }
  }

  selectTimezone(event): void {
    if (event.key === 'Enter' || event.type === 'click') {
      this.timezoneExpanded = '';
      this.completeProfileFormGroup.patchValue({
        timezone: event.value
      });
    }
  }

  showHidePassword(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.showPassword = !this.showPassword;
    }
  }

  resetInputField(event) {
    if (event.key === 'Enter' || event.type === 'click') {
      this.confirmPassword.setValue('');
    }
  }

  tooltipSonarFix(referenceName) {
    this[referenceName].nativeElement.href = 'javascript:void(0)';
  }

  //onclickingTimeZone
  onClickTimeZone(event) {
    if (event.target.ariaExpanded === 'true') {
      this.timezoneExpanded = 'dropdown-opened';
    } else {
      this.timezoneExpanded = '';
    }
  }

  @HostListener('document:click', ['$event']) clickout(event) {
    if (event.target.id !== 'select_security_question' && event.target.id !== 'time_zone') {
      this.timezoneExpanded = '';
      this.questionExpanded = '';
    }
  }

  confirmCheckbox(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.isChecked = !this.isChecked;
      if (this.isChecked) {
        this.termsConditionChecked = true;
        this.termsChecked.setValue(true);
      } else {
        this.termsConditionChecked = false;
        this.termsChecked.setValue(false);
      }
    }
  }


  disabledSubmitButton() {
    if (this.emailAddress.value === '' || this.emailAddress.value === undefined ||
      this.SecurityQuestionvalue.value === '' || this.SecurityQuestionvalue.value === undefined ||
      this.securityAnswer.value === undefined || this.securityAnswer.value.length < 3 ||
      this.timeZoneValue.value === '' || this.timeZoneValue.value === undefined ||
      this.termsConditionChecked === false || this.isChecked === false || !this.isPasswordValid || !this.checkPasswordMatch) {
      return true;
    } else {
      return false;
    }
  }

  pwdKeyup(e) {
    if (e.key === 'Enter' || e.type === 'click' || e.key === 'Tab') {
      this.isFocus = true;
    }
  }

  changeConfirmPassword(event) {
    if (this.isPasswordValid && this.newPassword.value === this.confirmPassword.value) {
      this.checkPasswordMatch = true;
    } else {
      this.checkPasswordMatch = false;
    }
  }

  pwdBlur() {
    this.isFocus = false;
  }

  isPasswordTooltipExpanded(event) {
    if (event !== undefined) {
      this.isFocusOn = event;
    }
  }

  //openingtheterms 
  openTerms(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.openTermsPage.emit(true);
    }
  }

  //submitButton
  submit(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      const profileInfo = {
        'action': 'fromPasswordPage',
        'pwd': this.newPassword.value,
        'securityQuestion': this.SecurityQuestionvalue.value,
        'securityAnswer': this.securityAnswer.value,
        'timeZone': this.timeZoneValue.value
      };
      //settingprofileInformationintosessionstorage
      sessionStorage.setItem('profileInformation', JSON.stringify(profileInfo));
      this.showCodeSection.emit(true);
      clearInterval(this.countDown);
    }
  }

  //CancelButton
  cancel(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      this.openCancelModal = 'open';
      this.showCancelModal = true;
    }
  }

  closeCancelModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  closeInactivityModal(event) {
    if (event === 'modalClose') {
      this.openInactivityModal = 'close';
    }
  }

  @HostListener('window:load')
  @HostListener('document:mousemove')
  @HostListener('document:keyup')
  @HostListener('document:click')
  @HostListener('window:scroll')
  @HostListener('document:touchstart', ['$event']) onMove($event?: any) {
    if (environment.enableSessionTimeout) {
      clearInterval(this.countDown);
      this.checkInactivity();
    }
  }

  checkInactivity() {
    const countDownDate = new Date().getTime() + 120000;
    this.countDown = setInterval(() => {
      const currentTime = new Date().getTime();
      const timeDiff = countDownDate - currentTime;

      if (timeDiff < 30000) {
        this.openInactivityModal = 'open';
        this.showCancelModal = false;
      }
      if (timeDiff < 0) {
        clearInterval(this.countDown);
        this.openInactivityModal = 'close';
        sessionStorage.clear();
        window.location.href = CfetPageNamesConstant.SESSION_TIME_OUT;
      }
    }, 350);
  }

}